import { useSelector } from "react-redux";
import { selectCurrent } from "../../../../redux/settings/selectors";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../hooks/hooks";
import { user } from "../../../../redux/user/actions";
import useWindowDimensions from '../../../../hooks/useWindowsDimensions';
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import storePersist from "../../../../redux/storePersist";
import CustomerAccountSettings from "../../../../components/customer/AccountSettings";

const CustomerHelpCenterMobile = () => {
	const navigate = useNavigate()
	const dispatch = useAppDispatch();
	const { register, handleSubmit, clearErrors, formState: { errors }, setValue } = useForm();
	const { height, width } = useWindowDimensions();
	const { theme } = useSelector(selectCurrent)
	const [color, setColor] = useState('universal')
	const [primary, setPrimary] = useState('#FFB934FF')
	const [secondary, setSecondary] = useState('#FFB934FF')
	const userProfileData = storePersist?.get("userProfile")?.current;

	useEffect(() => {
		setColor(theme)
		if (theme == 'darkmode') {
			setPrimary('#f5e93cac')
			setSecondary('#ffffff')
		}
		else if (theme == 'lightmode') {
			setPrimary('#ffffffa2')
			setSecondary('#000000a2')
		}
		else if (theme == 'universal') {
			setPrimary('#233C64')
			setSecondary('#ffffff')
		}
		else if (theme == 'luxury') {
			setPrimary('#bd238c')
			setSecondary('#ffffff')
		}
		else if (theme == 'harmony') {
			setPrimary('#000000a2')
			setSecondary('#000000a2')
		}
		else if (theme == 'warmth') {
			setPrimary('#000000a2')
		}
	}, [theme]);

	const handleSave = () => {
		dispatch(user.set({ isEditPersonalInfo: false }))
	}
	const handleLogout = () => {
		localStorage.removeItem('access-token')
		localStorage.removeItem('accessTokenMetadata')
		localStorage.removeItem('userProfile')
		localStorage.removeItem('google-login-role')
		navigate('/auth/login/customer')
	}
	return (

		<div className={`max-h-screen`}>

			<div className="z-20 h-full py-10 pb-24 overflow-y-auto ">
				<form onSubmit={handleSubmit(handleSave)} >
					<div className="w-full  rounded-lg  flex flex-col  text-black p-5">
						<div className="flex flex-col items-start justify-between w-full space-y-3 border-b p-2 border-blue-500">
							<div className="flex w-full flex-col items-start justify-between text-xl" >
								Ticket Details
							</div>
						</div>
						<div className="flex flex-col items-start justify-between w-full space-y-3 border-b p-2 border-blue-500">
							<div className="flex w-full flex-col items-start justify-between text-xs" >
								Date : 17-Apr-2024
							</div>
							<div className="flex w-full flex-col items-start justify-between text-xs" >
								Ticke Ref : #23879900-02
							</div>
							<div className="flex w-full flex-row items-start justify-start text-xs" >
								Status : <span className="bg-red-300 w-max rounded">In Progress</span>
							</div>
						</div>
						<div className="flex flex-col items-start justify-between w-full space-y-3 border-b p-2 border-blue-500">
							<div className="flex w-full flex-col items-start justify-between text-xs" >
								Date : 11-Mar-2024
							</div>
							<div className="flex w-full flex-col items-start justify-between text-xs" >
								Ticke Ref : #111-79900-02
							</div>
							<div className="flex w-full  flex-row items-start justify-start text-xs" >
								Status : <span className="bg-blue-300 w-max rounded">Closed</span>
							</div>
						</div>
						<div className="w-full flex text-center mt-6">
							<input type="submit"
								className="bg-red-500 text-white text-xl p-2 w-full"
								value='Write Us : support@digiit.co'
							/>
						</div>
						<div className="w-full flex text-center mt-6">
							<input type="submit"
								className="bg-red-500 text-white text-xl p-2 w-full"
								value='Call Center : 1011-22344-456'
							/>
						</div>
					</div>
				</form>
			</div>

		</div >

	)
}

export default CustomerHelpCenterMobile

